// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"1eab2627","845":"02575314"}[chunkId] + ".chunk.js";
};